import { useState, useEffect } from "react";
import { Topico } from "../TopicosTypes";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export const useTopicosState = () => {
  // Estados para os tópicos e filtros
  const [topicos, setTopicos] = useState<Topico[]>([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [disciplinaFiltro, setDisciplinaFiltro] = useState("");
  const [professorFiltro, setProfessorFiltro] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;

  // Estados para a adição de aula
  const [tituloNovaAula, setTituloNovaAula] = useState("");
  const [descricaoNovaAula, setDescricaoNovaAula] = useState("");

  // Estados para modais de edição/exclusão
  const [isOpenEdit, setIsOpenEdit] = useState(false);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [currentTopico, setCurrentTopico] = useState<Topico | null>(null);

  // Buscar todos os tópicos do banco de dados quando a página carrega
  useEffect(() => {
    const fetchTopicos = async () => {
      try {
        setLoading(true);
        const { data, error } = await supabase
          .from('topicos')
          .select('*')
          .order('created_at', { ascending: false });
        
        if (error) throw error;
        
        // Transformar os dados do Supabase para o formato usado na aplicação
        const formattedTopicos: Topico[] = data?.map(item => ({
          id: item.id,
          titulo: item.nome,
          thumbnail: "",
          patrocinador: item.patrocinador || "",
          disciplina: item.disciplina,
          videoUrl: item.video_url || "",
          pdfUrl: item.pdf_url || "",
          teoriaId: (item as { teoria_id?: string | null }).teoria_id || null,
          mapaUrl: item.mapa_url || "",
          resumoUrl: item.resumo_url || "",
          musicaUrl: item.musica_url ? item.musica_url.split(',').filter(Boolean) : [],
        resumoAudioUrl: item.resumo_audio_url ? item.resumo_audio_url.split(',').filter(Boolean) : [],
          cadernoQuestoesUrl: item.caderno_questoes_url || "",
          questoesIds: item.questoes_ids || [],
          professor_id: item.professor_id || "",
          professor_nome: item.professor_nome || "",
          selecionado: false,
          abrirEmNovaGuia: item.abrir_em_nova_guia || false
        })) || [];
        
        setTopicos(formattedTopicos);
      } catch (error) {
        console.error("Erro ao buscar tópicos:", error);
        toast.error("Erro ao carregar os tópicos. Tente novamente.");
      } finally {
        setLoading(false);
      }
    };

    fetchTopicos();
  }, []);

  return {
    topicos,
    setTopicos,
    loading,
    searchTerm,
    setSearchTerm,
    disciplinaFiltro,
    setDisciplinaFiltro,
    professorFiltro,
    setProfessorFiltro,
    currentPage,
    setCurrentPage,
    itemsPerPage,
    tituloNovaAula,
    setTituloNovaAula,
    descricaoNovaAula,
    setDescricaoNovaAula,
    isOpenEdit,
    setIsOpenEdit,
    isOpenDelete,
    setIsOpenDelete,
    currentTopico,
    setCurrentTopico
  };
};
